import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import QrcodeTable from "./QrcodeTable";
import { getQrcode } from "services/qrcode.routes";
import queryString from "utils/queryString";

export default function Qrcode() {
    const [searchParams] = useSearchParams()
    const [trigger, setTrigger] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [qrcode, setQrcode] = useState([]);
    const ghollak_id = searchParams.get("ghollak_id")
    const investor_id = searchParams.get("investor_id")

    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            with_ghollak: 1,
            with_user: 1,
            ghollak_id: ghollak_id || null,
            user_id: investor_id || null
        }
        getQrcode(queryString(query), (isOk, data) => {
            if (!isOk) {
                setLoading(false);
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setQrcode((prev) => ([...prev, ...data.data]));
                } else {
                    setQrcode(data.data);
                }
                setLoading(false);
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                if (data.meta.next_cursor !== null)
                    return setHasMore(true);

                else return setHasMore(false)
            }
        }, trigger !== null)

    }, [page, trigger]);
    useEffect(() => {
        if (searchParams.get("update")) {
            if (page === 0)
                setTrigger(Math.random());
            else
                setPage(0);

            setCursor(null);
        }
    }, [searchParams.get("update")]);
    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }

    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={qrcode.length} next={fetchMoreData} hasMore={hasMore}>
                <QrcodeTable data={qrcode} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}
